import { useState, useEffect } from "react";
import { Container, Card, Form, Button, Spinner } from 'react-bootstrap';
import axios from "../api/axios";
import Cookies from "js-cookie";
import { useNavigate, Link } from "react-router-dom";
import { FaUserShield, FaArrowLeft } from 'react-icons/fa';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    const payload = {
      username,
      password: btoa(password),
      loginType: "regular", // Hardcode to admin login
    };

    try {
      const res = await axios.post(
        `${BASE_URL}/login/doLogin`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (res.data.status === "1") {
        const user = res.data.userdetails[0];
        const token = user.token;

        Cookies.set("token", token, { expires: 1 });
        localStorage.setItem("user", JSON.stringify(user));
        Cookies.set("userRole", "admin", { expires: 1 });
        setTimeout(() => {
          navigate("/admin/dashboard");
        }, 800);
      } else {
        const errorMsg = res.data.message || "Login failed";
        setError(errorMsg);
        alert(errorMsg);
      }
    } catch (err) {
      const errorMsg = err.response?.data?.message || "Invalid credentials";
      setError(errorMsg);
      alert(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)' 
    }}>
      <Container style={{ maxWidth: '450px' }}>
        <Card className="shadow-lg border-0 rounded-3">
          <Card.Body className="p-5">
            <div className="text-center mb-4">
              <div style={{
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                background: 'var(--accent-gradient, linear-gradient(135deg, #2563eb, #7c3aed))',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1rem'
              }}>
                <FaUserShield size={40} />
              </div>
              <h2 className="fw-bold">Admin Portal</h2>
              <p className="text-muted">Sign in to continue.</p>
            </div>
            
            <Form onSubmit={handleLogin}>
              {error && <p className="text-danger text-center small">{error}</p>}
              
              <Form.Group className="mb-3" controlId="username">
                <Form.Label>Username</Form.Label>
                <Form.Control 
                  type="text" 
                  placeholder="Enter username" 
                  required 
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  disabled={isLoading}
                />
              </Form.Group>

              <Form.Group className="mb-4" controlId="password">
                <Form.Label>Password</Form.Label>
                <Form.Control 
                  type="password" 
                  placeholder="Enter password" 
                  required 
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={isLoading}
                />
              </Form.Group>

              <Button 
                variant="primary" 
                type="submit" 
                className="w-100 btn-primary"
                size="lg"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                    Signing In...
                  </>
                ) : (
                  'Sign In'
                )}
              </Button>

              <div className="text-center mt-4">
                <Link to="/" className="text-muted text-decoration-none">
                  <FaArrowLeft size={12} className="me-2" />
                  Back to Home
                </Link>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}